import React from 'react';
import { cn } from '../../helpers/utils';
import { cva, VariantProps } from 'class-variance-authority';

export const panelVariants = cva(
  'panel',
  {
    variants: {
      variant: {
        default: 'panel--default',
        collapsed: 'panel--collapsed',
      },
      position: {
        default: 'panel--position-default',
        last: 'panel--position-last',
      },
    },
    defaultVariants: {
      variant: 'default',
      position: 'default',
    },
  },
)
interface PanelProps extends React.HTMLAttributes<HTMLElement>, VariantProps<typeof panelVariants> {
  key?: React.Key;
}
interface PanelSubcomponentProps extends React.HTMLAttributes<HTMLElement> {}

function PanelContent({ children, className, ...props }: PanelSubcomponentProps){
  return <div className={cn('w-full lg:w-2/3 relative z-20 pt-4 px-4 pb-6 md:pl-8 md:pr-10 md:pt-8 md:pb-12', className) + ' border-shadow border-shadow--right'} {...props}>
    {children}
  </div>
}

function PanelSidebar({ children, className, ...props }: PanelSubcomponentProps){
  return <div className={cn('w-full lg:w-1/3 relative z-10 pt-4 px-4 pb-6 md:pr-8 md:pl-10 md:pt-8 md:pb-12', className)} {...props}>
    {children}
  </div>
}

const Panel: ({ className, children, ...props }: PanelProps)
  => React.JSX.Element = ({ className, children, variant, position, ...props }: PanelProps) => {
  return (
    <section className={cn(panelVariants({ variant, position }), className)} {...props}>
      {children}
    </section>
  );
};

Panel.displayName = "Panel";

interface PanelSubcomponents extends React.FC<PanelProps> {
  Content: typeof PanelContent;
  Sidebar: typeof PanelSidebar;
}

// Attach the subcomponents to the Panel
const PanelWithSubcomponents: PanelSubcomponents = Panel as PanelSubcomponents;
PanelWithSubcomponents.Content = PanelContent;
PanelWithSubcomponents.Sidebar = PanelSidebar;

export default PanelWithSubcomponents;